var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small"},scopedSlots:_vm._u([{key:"account_number",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.account ? row.account.account_number : '')+"\n    ")]}},{key:"account_name",fn:function(ref){
var row = ref.row;
return [_vm._v("\n      "+_vm._s(row.account ? row.account.account_name_en : '')+"\n      "+_vm._s(row.account.account_name_kh ? '|' + row.account.account_name_kh : '')+"\n    ")]}},{key:"debit_amount",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.debit_amount,"currency_id":row.currency_id}})]}},{key:"credit_amount",fn:function(ref){
var row = ref.row;
return [_c('ts-display-currency',{attrs:{"amount":row.credit_amount,"currency_id":row.currency_id}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }